import { AccessorsMutatorsDecorator, Model } from "../../helpers";

/**
 * @class ChannelManagerGlobalSettings
 *
 */
export class PropertyChannelModel extends Model {}

AccessorsMutatorsDecorator(
    'id',
    'property_id',
    'channel_id',
    'currency_id',
    'currency',
    'channel'
)(PropertyChannelModel);


// WEBPACK FOOTER //
// ./src/pms-api/models/property-channel.model.js